import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { Container } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { LOGIN_TOKEN_COOKIE_NAME, userDetail } from '../store/auth';
import { getCookie } from '../utils/cookie';

import ConversionRates from '../applications/conversion-rates';
import Login from '../applications/dashboard/pages/Login/Login';
import Landing from '../applications/dashboard/pages/Landing/Landing';
import MonitoringDashboard from '../applications/monitoring-dashboard';
import PaymentOptions from '../applications/payment-options';
import PaymentConfigList from '../applications/payment-configuration';
import PaymentOrchestration from '../applications/payment-orchestration';
import PaymentSearch from '../applications/payment-search';
import UserManagement from '../applications/user-management';
import SmartAlerts from '../applications/smart-alerts';
import LegacyPaymentOptions from '../applications/legacy-payment-options';
import Uploads from '../applications/uploads';

import styles from './App.module.scss';
import theme from './App.theme';

function App() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = getCookie(LOGIN_TOKEN_COOKIE_NAME);
    if (token) {
      dispatch(userDetail()).then(() => {
        setIsLoading(false);
      });
    } else setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        navigate('/login');
      }
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    !isLoading && (
      <ThemeProvider theme={theme}>
        <Container
          className={styles.App}
          maxWidth="xm"
          style={{ padding: 0 }}>
          <Routes>
            <Route
              path="/"
              exact
              element={<Landing />}
            />
            <Route
              path="/login"
              exact
              element={<Login />}
            />
            <Route
              path="/landing"
              element={<Landing />}
            />
            <Route
              path="/smart-alerts/*"
              element={<SmartAlerts />}
            />
            <Route
              path="/payment-config/*"
              element={<PaymentConfigList />}
            />
            <Route
              path="/monitoring-dashboard/*"
              element={<MonitoringDashboard />}
            />
            <Route
              path="/payment-search/*"
              element={<PaymentSearch />}
            />
            <Route
              path="/user-management/*"
              element={<UserManagement />}
            />
            <Route
              path="/conversion-rates/*"
              element={<ConversionRates />}
            />
            <Route
              path="/payment-options/*"
              element={<PaymentOptions />}
            />
            <Route
              path="/payment-orchestration/*"
              element={<PaymentOrchestration />}
            />
            <Route
              path="/legacy-payment-options/*"
              element={<LegacyPaymentOptions />}
            />
            <Route
              path="/uploads/*"
              element={<Uploads />}
            />
          </Routes>
        </Container>
      </ThemeProvider>
    )
  );
}

export default App;
